<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from 'cn'

interface Props {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
</script>

<template>
  <span
    data-slot="marker-content"
    :class="cn('group-data-[variant=separator]/marker:flex-none group-data-[variant=separator]/marker:text-center *:[a]:hover:text-foreground *:[a]:underline *:[a]:underline-offset-4 min-w-0 break-words', props.class)"
  >
    <slot />
  </span>
</template>
